import request from 'sb-request'


const send = (body) =>
  request.post('/rest/incubator/concepts', {
    body,
  })

export default {
  send,
}
